module.exports = __webpack_public_path__ + "static/media/Whitefeather.c0809615.ttf";